export default __webpack_public_path__ + "static/affiliate-program-Software-1-67432e5824a8f71a90b423dca8f303ba.webp";